import { createTimeline, stagger } from 'animejs';

const slideAnimation = (text, image, hotspots, beginFunction, endFunction, windowWidth) => {
  if (!text.current || !image.current || !hotspots.current) {
    return null;
  }

  const hotspotElems = [...hotspots.current.querySelectorAll('.hotspot')];

  const animeTimeline = createTimeline({
    autoplay: false,
    onBegin: () => {
      if (beginFunction) beginFunction();
    },
    onComplete: () => {
      // CLEAR INLINE TRANSFORMS
      // This allows CSS Breakpoints/Flexbox to take back control on resize
      [text.current, image.current].forEach((el) => {
        if (el) {
          el.style.transform = '';
        }
      });

      hotspotElems.forEach((el) => {
        if (el) el.style.transform = '';
      });

      if (endFunction) endFunction();
    },
  });

  if (windowWidth < 1024) {
    animeTimeline
      .add(
        image.current,
        {
          ease: 'inQuint',
          opacity: [0, 1],
          duration: 1000,
        },
        0,
      )
      .add(
        text.current,
        {
          ease: 'outQuint',
          translateY: [50, 0],
          opacity: [0, 1],
        },
        600,
      );

    if (hotspotElems.length > 0) {
      animeTimeline.add(
        hotspotElems,
        {
          ease: 'outElastic(1, .6)',
          opacity: [0, 1],
          translateY: [40, 0],
          delay: stagger(200),
          scale: [0.8, 1],
        },
        1000,
      );
    }
  } else {
    animeTimeline
      .add(
        image.current,
        {
          ease: 'inQuint',
          opacity: [0.1, 1],
          duration: 2400,
          scale: [1.4, 1],
          translateX: [-200, 0],
        },
        0,
      )
      .add(
        text.current,
        {
          ease: 'outQuint',
          translateX: [-20, 0],
          opacity: [0, 1],
        },
        2300,
      );

    if (hotspotElems.length > 0) {
      animeTimeline.add(
        hotspotElems,
        {
          ease: 'outElastic(1, .6)',
          opacity: [0, 1],
          translateY: [40, 0],
          delay: stagger(200),
          scale: [0.8, 1],
        },
        3100,
      );
    }
  }

  return animeTimeline;
};

export default slideAnimation;
